module.exports = __webpack_public_path__ + "static/media/reason.5a04da79.svg";